import React, { useEffect } from 'react';
// Styles
import classes from './styles.module.scss';

const TermsOfServicePage:React.FC = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <section
      className={classes.page}
    >
      <div className="container">
        <h2 className={classes.title}>Terms of Service</h2>
        <p className={classes.text}><strong>Effective date:</strong> August 31, 2025</p>

        <h3 className={classes.subtitle}>Agreement</h3>
        <p className={classes.text}>By using our website or services, you agree to these Terms of Service.</p>

        <h3 className={classes.subtitle}>Services</h3>
        <p className={classes.text}>MouseOver provides IT development and related services. Details, deliverables, and pricing are set out in contracts or proposals.</p>

        <h3 className={classes.subtitle}>Fees & Payment</h3>
        <p className={classes.text}>Fees are specified in agreements or invoices. EU clients may be subject to VAT. Payments must be made by the due date.</p>

        <h3 className={classes.subtitle}>Intellectual Property</h3>
        <p className={classes.text}>We retain ownership of our intellectual property. Rights to deliverables transfer to clients upon full payment, as defined in contracts.</p>

        <h3 className={classes.subtitle}>Confidentiality</h3>
        <p className={classes.text}>Both parties agree to keep confidential information secure and not disclose it without consent.</p>

        <h3 className={classes.subtitle}>Liability</h3>
        <p className={classes.text}>We are not liable for indirect or consequential damages. Liability is limited to the amount paid for services in the past 12 months.</p>

        <h3 className={classes.subtitle}>Termination</h3>
        <p className={classes.text}>Either party may terminate for material breach with notice. We may suspend or terminate services for non-payment or misuse.</p>

        <h3 className={classes.subtitle}>Governing Law</h3>
        <p className={classes.text}>For EU clients, Estonian law applies. For non-EU clients, Ukrainian law applies, unless otherwise agreed.</p>

        <h3 className={classes.subtitle}>Contact</h3>
        <p className={classes.text}>Email: <a href="mailto:privacy@mouseover.io">privacy@mouseover.io</a></p>
        <p className={classes.text}>EU: Overmind OÜ, Harju maakond, Tallinn, Lasnamäe linnaosa, Sepapaja tn 6, 11415</p>
        <p className={classes.text}>Non-EU: MouseOver LLC, 79012, Ukraine, Lviv, Sakharova street 42</p>
      </div>
    </section>
  );
}

export default TermsOfServicePage;
